import { Component, input } from '@angular/core';

/** Mensaje de validación inline debajo del campo (texto rojo, sin tarjeta). */
@Component({
  selector: 'app-vault-form-validation-alert',
  standalone: true,
  templateUrl: './form-validation-alert.component.html',
  styleUrls: ['./form-validation-alert.component.scss'],
})
export class VaultFormValidationAlertComponent {
  readonly message = input<string | null>(null);
}
